import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1433 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1433 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-right\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 560.128l79.1552-111.0016L451.2768 732.16 1357.312 0 1433.6 72.4992 457.6256 1024z\" fill=\"#2ec5c2\" p-id=\"2382\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol